import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  //Solicitar los datos generales del cliente para el pedido
  {
    path: "/pedido/configurarproducto/",
    name: "configurarproducto",
    component: () =>
      import("@/views/productos/ConfiguraProductoAgregarView.vue"),
  },
  //Solicitar los datos generales del cliente para el pedido
  {
    path: "/pedido/datos",
    name: "solicitadatoscliente",
    component: () =>
      import("@/views/pedidos/DatosClientePedidoView.vue"),
  },
  //Reservación creada
  {
    path: "/reservacion/creada",
    name: "avisoReservacionCreada",
    component: () =>
      import("@/views/FilasDeEspera/ReservacionCreada.vue"),
  },
  //Validar la reserva del cliente
  {
    path: "/reservacion/confirma",
    name: "confirmaCorreoCliente",
    component: () =>
      import("@/views/FilasDeEspera/ValidaCorreoCliente.vue"),
  },
  //Ver menú completo
  {
    path: "/menux/:acceso",
    name: "menucompleto",
    component: () =>
      import("@/views/presentacion/VerMenuCompleto.vue"),
  },
  //Ver pedidos del usuario
  {
    path: "/pedidos",
    name: "pedidos",
    component: () =>
      import("@/views/pedidos/VerPedidosView.vue"),
  },
  //Opciones de la cuenta del usuario
  {
    path: "/cuenta",
    name: "cuentausuario",
    component: () =>
      import("@/views/cuenta/OpcionesCuentaUsuario.vue"),
  },
  {
    path: "/fila/:acceso",
    name: "Fila",
    component: () =>
      import("@/views/FilasDeEspera/FilaDeEspera.vue"),
  },
  {
    path: "/reservacion/:acceso",
    name: "Reservacion",
    component: () =>
      import("@/views/FilasDeEspera/CrearReservacion.vue"),
  },

  {
    path: "/bp/:claveInstancia",
    name: "busqueda",
    component: () =>
      import("@/views/BuscaProductos.vue"),
  },
  //configura pedido
  {
    path: "/peiddos/configura/:claveInstancia",
    name: "configuraPedido",
    component: () =>
      import("@/views/pedidos/ConfiguraGeneralesPedidoView.vue"),
  },

  {
    //PRESENTACIÓN
    path: "/presenta/vermenu/:claveMenuDigitalDetalle",
    name: "presentacionMenu",
    component: () =>
      import("@/views/presentacion/VerMenu.vue"),
  },
  {
    //PRESENTACIÓN
    path: "/presenta/:claveInstancia",
    name: "presentacion",
    component: () =>
      import("@/views/presentacion/Presentacion.vue"),
  },
  {
    //RECUPERAR CONTRASEÑA
    path: "/recuperacontra/:claveInstancia",
    name: "recuperaContrasenia",
    component: () =>
      import("@/views/RecuperarContrasenia.vue"),
  },
  {
    //PEDIDO CONFIRMADO
    path: "/pedidoConfirma/:claveInstancia",
    name: "confirmaPedido",
    component: () =>
      import("@/views/pedidos/PedidoConfirmadoView.vue"),
  },
  {
    //LOGIN CLIENTE
    path: "/login/:claveInstancia/:regresa",
    name: "login",
    component: () =>
      import("@/views/Login.vue"),
  },
  {
    //REGISTRO CLIENTE
    path: "/registrame/:claveInstancia",
    name: "registraCliente",
    component: () =>
      import("@/views/RegistroCliente.vue"),
  },
  {
    //VER CARRITO
    path: "/carrito/:claveInstancia",
    name: "carrito",
    component: () =>
      import("@/views/pedidos/VerCarritoView.vue"),
  },
  {
    //Ver producto
    path: "/producto/:claveProducto/:claveInstancia/:regreso",
    name: "verProducto",
    component: () =>
      import("@/views/VerProductoView.vue"),
  },
  //Este es el arranque
  {
    path: "/m/:claveInstancia",
    name: "publicidad",
    component: () =>
      import("@/views/PublicidadInicial.vue"),
  },
  //Página principal de los menus
  {
    path: "/main/:claveInstancia",
    name: "menus",
    component: () =>
      import("@/views/presentacion/VerMenuCompleto.vue"),
  },
  {
    path: "/vermenu/:claveInstancia/:claveMenuDigital/:claveMenuDigitalDetalle",
    name: "vermenu",
    component: () =>
      import("@/views/Vermenu.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
